import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        token: '',
    },
    mutations: {
        // 设置
        setKeyVal(state, data) {
            let { key, val } = data;
            state[key] = val;
        }
    },
    getters: {
     
    },
})


// WEBPACK FOOTER //
// ./src/store/index.js